@import '../../../theme.scss';

verdocs-button-panel {
  font-family: $verdocs-primary-font;
  display: inline-block;

  .icon {
    display: inline-block;
    cursor: pointer;
    opacity: 0.6;

    svg {
      fill: $border-color;
    }

    &:hover {
      opacity: 1;
    }
  }
}

.verdocs-button-panel-content {
  font-family: $verdocs-primary-font;
  box-shadow: 0 0 10px 1px #999999;
  display: none;
  background: #ffffff;
  color: $label-color;
  width: 320px;
  font-weight: bold;
  padding: 15px;
  font-size: 14px;
  position: relative;
  border-radius: 4px;
  z-index: 10000;

  .arrow,
  .arrow::before {
    position: absolute;
    width: 8px;
    height: 8px;
    background: inherit;
  }

  .arrow {
    visibility: hidden;
    top: -4px;
  }

  .arrow::before {
    visibility: visible;
    content: '';
    transform: rotate(45deg);
  }

  &[data-show] {
    display: block;
  }

  &[data-popper-placement^='top'] > .arrow {
    bottom: -4px;
  }

  &[data-popper-placement^='bottom'] > .arrow {
    top: -4px;
  }

  &[data-popper-placement^='left'] > .arrow {
    right: -4px;
  }

  &[data-popper-placement^='right'] > .arrow {
    left: -4px;
  }

  h6 {
    font-size: 16px;
    font-weight: bold;
    margin: 0 0 16px 0;
    color: $verdocs-grey-0;
    border-bottom: 1px solid #cccccc;
  }
}
